import lazyLoadView from "@router/lazyload-view";

export default [
  // 404
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    meta: {
      showBreadcrumb: false,
    },
    props: true,
  },
  // 首頁
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/Home/Index')),
  },
  // 方案價格
  {
    path: '/planprice',
    name: 'planprice',
    component: () => lazyLoadView(import('@views/Plan/Index')),
  },
  // 預約系統方案 
  {
    path: '/reserveplan',
    name: 'reserveplan',
    component: () => lazyLoadView(import('@views/BasicPlan/Index')),
  },
  // 系統行銷整合方案
  {
    path: '/marketingplan',
    name: 'marketingplan',
    component: () => lazyLoadView(import('@views/IntermediatePlan/Index')),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => lazyLoadView(import('@views/Contact/Index')),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => lazyLoadView(import('@views/Privacy/Index')),
  },
  {
    path: '/line-notify',
    name: 'line-notify',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        const {code = undefined, state = undefined} = routeTo.query
        if (code === undefined && state === undefined) {
          next({
            name: 'home',
            replace: true,
          })
        } else {
          const bindUrl = state
          const success = !!code
          const url = `${bindUrl}?code=${code}&success=${success}`;
          window.location.href = url
        }
      }
    }
  },
  {
    path: '*',
    redirect: '404',
  },
]
